import React, { memo } from 'react';

import * as Types from './types';
import { GamesRow } from '../GamesRow';
import { GamesHeader } from '../GamesHeader';

import style from './GamesGridView.scss';

export const GamesGridViewBare: React.FC<Types.IGamesGridViewProps> = ({
    feedName,
    categoryName,
    allGamesCount,
    categoryRowsCount,
    categoryLayoutWithGames
}) => {
    return (
        <>
            <GamesHeader
                feedName={feedName}
                categoryName={categoryName}
                allGamesCount={allGamesCount}
                categoryRowsCount={categoryRowsCount}
                categoryLayoutWithGames={categoryLayoutWithGames}
            />
            <div className={`${style.gamesGridView} cms-games-grid-category-grid`}>
                {categoryLayoutWithGames.map((games, index) => {
                    if (categoryRowsCount && categoryRowsCount < index + 1) {
                        return null;
                    }

                    const isLastItem = (categoryRowsCount || categoryLayoutWithGames.length) === index + 1;

                    return (
                        <GamesRow
                            key={index}
                            games={games}
                            isLastItem={isLastItem}
                            categoryName={categoryName}
                        />
                    );
                }).filter(Boolean)}
            </div>
        </>
    );
};

export const GamesGridView = memo(GamesGridViewBare);
